import React, {useContext} from 'react';
import { Link } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import {Login, Person} from '@mui/icons-material'
import {FirebaseContext} from "../context";
import '../styles/TabNavBar.scss';

export default function TabNavBar({value}) {
  const firebase = useContext(FirebaseContext);
  const {user} = firebase;

  return <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
    <BottomNavigation
      showLabels
      value={value || 'expenses'}
    >
      <BottomNavigationAction to="/expenses" value="expenses" label="Expenses" icon={<PointOfSaleIcon />} component={Link} />
      <BottomNavigationAction to="/exchanges" value="exchanges" label="Exchanges" icon={<CurrencyExchangeIcon />} component={Link} />
      {user
        ?
        <BottomNavigationAction to="/profile" value="profile" label="Profile" icon={<Person />} />
        :
        <BottomNavigationAction to="/login" value="login" label="Login" icon={<Login />} />
      }
    </BottomNavigation>
    <div className="app-version">{import.meta.env.VITE_VERSION}</div>
  </Paper>;
}
